import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@mui/styles';

import EditInvitationSubscribe from './../edit/EditInvitationSubscribe';
import { DialogContent, DialogTitle } from '@mui/material';
import DialogBase from './DialogBase';

class DialogEditInvitationSubscribe extends React.Component {

  render () {
    const { classes, open, onClose, ...others } = this.props;
    const scrollableTargetId = "dialog-edit-invitation-subscribe";
    return (
      <DialogBase
        open={open}
        onClose={onClose}
      >
        <DialogTitle>Invitation</DialogTitle>
        <DialogContent classes={{root: classes.dialogContent}} id={scrollableTargetId}>
          <EditInvitationSubscribe
            scrollableTarget={scrollableTargetId}
            {...others}
          />
        </DialogContent>
      </DialogBase>
    )
  }
}

const styles = theme => ({
  dialogContent: {
    padding: theme.spacing(0),
  },
});

DialogEditInvitationSubscribe.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
};

export default withStyles(styles, { withTheme: true })(DialogEditInvitationSubscribe);
